import Seo from "../../components/Seo";
import { Reveal, Eyebrow, PageHero, CheckList, PhotoFrame, CtaBand, EASE } from "../../components/Shared";
import { motion } from "framer-motion";
import { PACKAGES, photo, fmt } from "../../data/site";
import { Link } from "react-router-dom";

export default function FullDetailing() {
  const [full, exclusive] = [PACKAGES[1], PACKAGES[2]];
  return (
    <>
      <Seo
        title="Full Auto Detailing Packages in Sioux Falls, SD | From $325 — A+ Detailing"
        description="Complete inside-and-out detailing in Sioux Falls: Full Auto Detailing from $325 and The Exclusive from $450 with clay bar, wheel decontamination & Rupes Nano protectant. Mobile & in-shop."
        path="/full-detailing"
      />
      <PageHero
        eyebrow="Full Detailing Packages"
        lines={["INSIDE", "AND OUT."]}
        lead="Two complete packages covering every surface of your vehicle — hand wash, wheels, tires, glass and a full interior detail. Available in-shop or mobile."

        chips={[`Full Auto from ${fmt(full.price)}`, `The Exclusive from ${fmt(exclusive.price)}`, "Flat rate by vehicle size"]}
        testPrefix="full"
      />

      <section className="mx-auto max-w-7xl px-5 sm:px-8 py-20 sm:py-28 space-y-8">
        {[
          { p: full, featured: false, test: "full-auto" },
          { p: exclusive, featured: true, test: "exclusive" },
        ].map(({ p, featured, test }, idx) => (
          <motion.div
            key={p.name}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.7, delay: idx * 0.1, ease: EASE }}
          >
            <div
              data-testid={`fulldetail-package-${test}`}
              className={`grid lg:grid-cols-2 gap-0 rounded-2xl border overflow-hidden ${
                featured ? "border-bright/50 bg-gradient-to-br from-bright/10 to-card" : "border-white/10 bg-card"
              }`}
            >
              <div className="p-8 sm:p-12">
                {featured && <span className="inline-block bg-bright text-white text-[11px] font-mono uppercase tracking-widest rounded-full px-3 py-1 mb-4">Flagship</span>}
                <h2 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight">{p.name}</h2>
                <div className="mt-6 flex flex-wrap gap-4">
                  <span className="glass border border-white/10 rounded-full px-5 py-2.5 text-sm">
                    In-shop from <strong className="text-bright">{fmt(p.price)}</strong>
                  </span>
                  <span className="glass border border-white/10 rounded-full px-5 py-2.5 text-sm">
                    Mobile from <strong className="text-bright">{fmt(p.mobilePrice)}</strong>
                  </span>
                </div>
                <p className="mt-5 text-steel leading-relaxed">{p.blurb}</p>
                <Link
                  to="/book"
                  data-testid={`fulldetail-book-${test}`}
                  className={`mt-8 inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-sm font-semibold transition-colors ${
                    featured ? "bg-bright hover:bg-accent text-white" : "border border-white/20 hover:border-bright hover:text-bright text-white"
                  }`}
                >
                  Book {p.name}
                </Link>
              </div>
              <div className="p-8 sm:p-12 border-t lg:border-t-0 lg:border-l border-white/10">
                <Eyebrow>Included services</Eyebrow>
                <div className="mt-6">
                  <CheckList items={p.includes} />
                </div>
              </div>
            </div>
          </motion.div>
        ))}
      </section>

      <CtaBand testPrefix="full" />
    </>
  );
}
